/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface RemoveRequest {
  org_id: string;
  /** @maxLength 320 */
  admin_email: string;
  /** @maxLength 255 */
  admin_user_id: string;
}
